const types = {
	//Get Template name
	GET_SUBSCRIPTIONPLAN_START: "GET_SUBSCRIPTIONPLAN_START",
	GET_SUBSCRIPTIONPLAN_SUCCESS: "GET_SUBSCRIPTIONPLAN_SUCCESS",
	GET_SUBSCRIPTIONPLAN_ERROR: "GET_SUBSCRIPTIONPLAN_ERROR",
	GET_SUBSCRIPTIONPLAN_RESET: "GET_SUBSCRIPTIONPLAN_RESET",

	//Create Template name
	CREATE_SUBSCRIPTIONPLAN_START: "CREATE_SUBSCRIPTIONPLAN_START",
	CREATE_SUBSCRIPTIONPLAN_SUCCESS: "CREATE_SUBSCRIPTIONPLAN_SUCCESS",
	CREATE_SUBSCRIPTIONPLAN_ERROR: "CREATE_SUBSCRIPTIONPLAN_ERROR",
	CREATE_SUBSCRIPTIONPLAN_RESET: "CREATE_SUBSCRIPTIONPLAN_RESET",

	//delete Template name
	DELETE_SUBSCRIPTIONPLAN_START: "DELETE_SUBSCRIPTIONPLAN_START",
	DELETE_SUBSCRIPTIONPLAN_SUCCESS: "DELETE_SUBSCRIPTIONPLAN_SUCCESS",
	DELETE_SUBSCRIPTIONPLAN_ERROR: "DELETE_SUBSCRIPTIONPLAN_ERROR",
	DELETE_SUBSCRIPTIONPLAN_RESET: "DELETE_SUBSCRIPTIONPLAN_RESET",

	//update Template name
	UPDATE_SUBSCRIPTIONPLAN_START: "UPDATE_SUBSCRIPTIONPLAN_START",
	UPDATE_SUBSCRIPTIONPLAN_SUCCESS: "UPDATE_SUBSCRIPTIONPLAN_SUCCESS",
	UPDATE_SUBSCRIPTIONPLAN_ERROR: "UPDATE_SUBSCRIPTIONPLAN_ERROR",
	UPDATE_SUBSCRIPTIONPLAN_RESET: "UPDATE_SUBSCRIPTIONPLAN_RESET",

	//single item  name
	SINGLE_SUBSCRIPTIONPLAN_START: "SINGLE_SUBSCRIPTIONPLAN_START",
	SINGLE_SUBSCRIPTIONPLAN_SUCCESS: "SINGLE_SUBSCRIPTIONPLAN_SUCCESS",
	SINGLE_SUBSCRIPTIONPLAN_ERROR: "SINGLE_SUBSCRIPTIONPLAN_ERROR",
	SINGLE_SUBSCRIPTIONPLAN_RESET: "SINGLE_SUBSCRIPTIONPLAN_RESET",
};

export default types;
